/* eslint-disable */
export default {
  status: 'ステータス',
  acceptQueueCalls: '通話キューの通話を承諾',
  callQueueDisabledReason: 'この設定は、貴社の管理者によって管理されています。',
  callQueueManagement: 'キューを管理',
} as const;

// @key: @#@"status"@#@ @source: @#@"Status"@#@
// @key: @#@"acceptQueueCalls"@#@ @source: @#@"Accept call queue calls"@#@
// @key: @#@"callQueueDisabledReason"@#@ @source: @#@"This setting is managed by your company administrator."@#@
// @key: @#@"callQueueManagement"@#@ @source: @#@"Manage queues"@#@
